export const brandBaanInitialState = {
  profiles: {
    data: [],
    loading: false,
    error: null,
  },
  voice: {
    data: [],
    loading: false,
    error: null,
  },
  voiceTrend: {
    data: [],
    loading: false,
    error: null,
  },
  contents: {
    data: [],
    loading: false,
    error: null,
  },
  nss: {
    data: null,
    loading: false,
    error: null,
  },
  nssTrend: {
    data: [],
    loading: false,
    error: null,
  },
  comments: {
    data: [],
    loading: false,
    error: null,
  },
  checkStatus: {
    data: {},
    loading: false,
    error: null,
  },
  brands: {
    data: [],
    loading: false,
    error: null,
  },
  reportage: {
    data: [],
    loading: false,
    error: null,
  },
  profileOverview: {
    data: [],
    loading: false,
    error: null,
  },
  commentsEmojis: {},
  reportageKeywords: {
    data: [],
    loading: false,
    error: null,
  },
  reportageList: {
    isModalOpen: false,
    data: [],
    loading: false,
    error: null,
  },
  storyPublicationComparison: {
    data: [],
    loading: false,
    error: null,
  },
  storyPublishment: {
    data: [],
    loading: false,
    error: null,
  },
  storyAnalytics: {
    data: [],
    loading: false,
    error: null,
  },
  brandDetails: {
    data: {},
    loading: false,
    error: null,
  },
};
